import { render } from "./TrainingAttendingView.vue?vue&type=template&id=6229c1ea&scoped=true"
import script from "./TrainingAttendingView.vue?vue&type=script&lang=js"
export * from "./TrainingAttendingView.vue?vue&type=script&lang=js"

import "./TrainingAttendingView.vue?vue&type=style&index=0&id=6229c1ea&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6229c1ea"]])

export default __exports__